import { render, staticRenderFns } from "./CourseAcademicDropdownSelector.vue?vue&type=template&id=193a4678"
import script from "./CourseAcademicDropdownSelector.vue?vue&type=script&lang=js"
export * from "./CourseAcademicDropdownSelector.vue?vue&type=script&lang=js"
import style0 from "./CourseAcademicDropdownSelector.vue?vue&type=style&index=0&id=193a4678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports